import DestekTalepleri from "./Modules/Destek/DestekTalepleri";
export default {
  namespaced: true,
  modules: {
    DestekTalepleri,
  },
};
